import React, { useState } from "react";
import { Card, Table, Dropdown, Form } from "react-bootstrap";
import { FiEdit, FiTrash } from "react-icons/fi";
import { BsCircleFill } from "react-icons/bs";
import EditLeaveModal from "../../modals/dashboard/hr-dashboard/EditLeaveModal";
import DeleteleaveListModal from "../../modals/dashboard/hr-dashboard/DeleteleaveListModal";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

export default function LeaveEmployeesList({
  leaves,
  onUpdateLeave,
  onDeleteLeave,
}) {
  const [search, setSearch] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [editItem, setEditItem] = useState(null);
  const [deleteItem, setDeleteItem] = useState(null);

  const filtered = leaves.filter((r) =>
    r.type.toLowerCase().includes(search.toLowerCase()),
  );

  const handleDelete = () => {
    if (deleteItem) {
      onDeleteLeave(deleteItem.id);
      setDeleteItem(null);
    }
  };

  const handleStatusChange = (item, newStatus) => {
    const updatedLeave = { ...item, status: newStatus };
    onUpdateLeave(updatedLeave);
  };

  return (
    <div>
      <Card className="leave-card mt-3">
        <Card.Header className="leave-header">
          <div className="header-top">
            <div className="left-section">
              <h5 className="title">Leave List</h5>

              <span className="badge badge-total">Total Leaves : 48</span>

              <span className="badge badge-remaining">
                Total Remaining Leaves : 23
              </span>
            </div>

            <div className="filter-section">
              {/* Date Range */}

              <Dropdown>
                <Dropdown.Toggle className="filter-btn ">
                  <i className="ti ti-calendar me-2"></i>
                  03/06/2026 - 03/12/2026
                </Dropdown.Toggle>

                <Dropdown.Menu className="filter-menu">
                  <Dropdown.Item>Today</Dropdown.Item>
                  <Dropdown.Item>Yesterday</Dropdown.Item>
                  <Dropdown.Item className="active-item">
                    Last 7 Days
                  </Dropdown.Item>
                  <Dropdown.Item>Last 30 Days</Dropdown.Item>
                  <Dropdown.Item>This Year</Dropdown.Item>
                  <Dropdown.Item>Next Year</Dropdown.Item>
                  <Dropdown.Item>Custom Range</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>

              {/* Leave Type */}

              <Dropdown>
                <Dropdown.Toggle className="filter-btn">
                  Leave Type
                </Dropdown.Toggle>

                <Dropdown.Menu className="filter-menu">
                  <Dropdown.Item>Medical Leave</Dropdown.Item>
                  <Dropdown.Item>Casual Leave</Dropdown.Item>
                  <Dropdown.Item>Annual Leave</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>

              {/* Approved By */}

              <Dropdown>
                <Dropdown.Toggle className="filter-btn">
                  Approved By
                </Dropdown.Toggle>

                <Dropdown.Menu className="filter-menu">
                  <Dropdown.Item>Doglas Martini</Dropdown.Item>
                  <Dropdown.Item>Warren Morales</Dropdown.Item>
                  <Dropdown.Item>Doglas Martini</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>

              {/* Status */}

              <Dropdown>
                <Dropdown.Toggle className="filter-btn">
                  Select Status
                </Dropdown.Toggle>

                <Dropdown.Menu className="filter-menu">
                  <Dropdown.Item>
                    <span className="dot success"></span>
                    Approved
                  </Dropdown.Item>

                  <Dropdown.Item>
                    <span className="dot danger"></span>
                    Declined
                  </Dropdown.Item>

                  <Dropdown.Item>
                    <span className="dot purple"></span>
                    New
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>

              {/* Sort */}

              <Dropdown>
                <Dropdown.Toggle className="filter-btn">
                  Sort By : Last 7 Days
                </Dropdown.Toggle>

                <Dropdown.Menu className="filter-menu">
                  <Dropdown.Item>Recently Added</Dropdown.Item>
                  <Dropdown.Item>Ascending</Dropdown.Item>
                  <Dropdown.Item>Descending</Dropdown.Item>
                  <Dropdown.Item>Last Month</Dropdown.Item>
                  <Dropdown.Item>Last 7 Days</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>

          {/* SECOND ROW */}

          <div className="header-bottom">
            <div>
              Row Per Page
              <Form.Select
                className="row-select"
                value={rowsPerPage}
                onChange={(e) => setRowsPerPage(e.target.value)}
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
              </Form.Select>
              Entries
            </div>

            <Form.Control
              className="search-input"
              placeholder="Search"
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </Card.Header>
        <Card.Body className="p-0">
          <div className="table-responsive">
            <Table className="table align-middle mb-0">
              <thead className="thead-light">
                <tr>
                  <th></th>
                  <th>Leave Type</th>
                  <th>From</th>
                  <th>Approved By</th>
                  <th>To</th>
                  <th>No of Days</th>
                  <th>Status</th>
                  <th></th>
                </tr>
              </thead>

              <tbody>
                {filtered.slice(0, rowsPerPage).map((item) => (
                  <tr key={item.id}>
                    <td>
                      <Form.Check />
                    </td>

                    <td>{item.type}</td>

                    <td>{item.from}</td>

                    <td>
                      <div className="d-flex align-items-center">
                        <img src={item.avatar} className="avatar-img" />

                        <div className="ms-2">
                          <div className="fw-semibold">{item.name}</div>
                          <div className="text-muted small">{item.role}</div>
                        </div>
                      </div>
                    </td>

                    <td>{item.to}</td>

                    <td>{item.days}</td>

                    <td>
                      <Dropdown>
                        <Dropdown.Toggle
                          variant="light"
                          size="sm"
                          className="status-btn no-arrow d-flex align-items-center"
                        >
                          <BsCircleFill
                            className={
                              item.status === "Approved"
                                ? "text-success me-2"
                                : item.status === "Declined"
                                  ? "text-danger me-2"
                                  : "text-purple me-2"
                            }
                          />

                          {item.status}

                          <KeyboardArrowDownIcon
                            style={{ fontSize: 18, marginLeft: "6px" }}
                          />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={() => handleStatusChange(item, "Approved")}
                          >
                            <BsCircleFill className="text-success me-2" />
                            Approved
                          </Dropdown.Item>

                          <Dropdown.Item
                            onClick={() => handleStatusChange(item, "Declined")}
                          >
                            <BsCircleFill className="text-danger me-2" />
                            Declined
                          </Dropdown.Item>

                          <Dropdown.Item
                            onClick={() => handleStatusChange(item, "New")}
                          >
                            <BsCircleFill className="text-purple me-2" />
                            New
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>

                    <td>
                      <div className="d-flex gap-3">
                        <FiEdit
                          className="action-icon"
                          onClick={() => setEditItem(item)}
                        />

                        <FiTrash
                          className="action-icon"
                          onClick={() => setDeleteItem(item)}
                        />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </Card.Body>
      </Card>

      <EditLeaveModal
        show={!!editItem}
        data={editItem}
        onHide={() => setEditItem(null)}
        onSave={(updatedLeave) => {
          onUpdateLeave(updatedLeave);
          setEditItem(null);
        }}
      />

      <DeleteleaveListModal
        show={!!deleteItem}
        onHide={() => setDeleteItem(null)}
        onDelete={handleDelete}
      />

      <style>{`

.leave-card{
border-radius:10px;
border:1px solid #eee;
}

.avatar-img{
width:40px;
height:40px;
border-radius:50%;
object-fit:cover;
}

.status-btn{
display:flex;
align-items:center;
}

.action-icon{
cursor:pointer;
font-size:18px;
}

.bg-primary-transparent{
background:#e7f1ff;
color:#0d6efd;
}

.bg-secondary-transparent{
background:#eef1f4;
}

.text-purple{
color:#8e44ad;
}
.leave-header{
background:#fff;
padding:15px 20px;
}

.header-top{
display:flex;
justify-content:space-between;
flex-wrap:wrap;
gap:10px;
}

.left-section{
display:flex;
align-items:center;
gap:10px;
}

.title{
font-weight:600;
}

.badge-total{
background:#ffe6d8;
color:#ff6b00;
}

.badge-remaining{
background:#e9f2fb;
color:#0d6efd;
}

.filter-section{
display:flex;
gap:10px;
flex-wrap:wrap;
}

.filter-btn{
background:#fff;
border:1px solid #ddd;
font-size:14px;
color:#1f2937;   /* dark text */
font-weight:500;
display:flex;
align-items:center;
}

.filter-btn:hover{
background:#fff;
color:#1f2937;
border:1px solid #ddd;
}

.filter-btn:focus{
box-shadow:none;
color:#1f2937;
}

.active-item{
background:#f26522;
color:#fff;
}

.header-bottom{
display:flex;
justify-content:space-between;
margin-top:15px;
flex-wrap:wrap;
gap:10px;
}

.row-select{
width:80px;
display:inline-block;
margin:0 10px;
}

.search-input{
width:220px;
}

.dot{
width:10px;
height:10px;
border-radius:50%;
display:inline-block;
margin-right:8px;
}
.no-arrow::after {
  display: none !important;
}

.success{background:#22c55e;}
.danger{background:#ef4444;}
.purple{background:#a855f7;}
.filter-btn::after{
border-top-color:#1f2937;
.filter-btn::after{
border-top-color:#1f2937;


`}</style>
    </div>
  );
}
